import { render, staticRenderFns } from "./PageGoalStatusReport.vue?vue&type=template&id=4abedf2a&"
import script from "./PageGoalStatusReport.vue?vue&type=script&lang=js&"
export * from "./PageGoalStatusReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports